<template>
  <div class="home_page">
    <!-- <div class="search_div">
      <el-input
        placeholder="请输入备件名称/编码"
        clearable
        v-model.trim="dataForm.inputText"
      >
        <template slot="append">
          <el-button
            slot="append"
            type="primary"
            icon="el-icon-search"
            @click="searchHandle"
            >搜索</el-button
          >
        </template>
      </el-input>
    </div> -->
    <div class="goods_category_list">
      <!-- 级别类目 -->
      <el-row class="category_row" v-if="categoryList && categoryList.length">
        <el-col :span="3" class="row_lable">目录</el-col>
        <el-col :span="19">
          <el-row
            v-for="(ele, idx) in Math.ceil(categoryList.length / 8)"
            :key="idx"
            v-show="showMoreCategory || idx == 0"
          >
            <el-col
              :span="3"
              class="ellipsis category-item"
              v-for="(item, index) in categoryList.slice(idx * 8, idx * 8 + 8)"
              :key="item.foregroundCategoryId"
              v-show="showMoreCategory || idx == 0"
            >
              <el-popover
                placement="bottom"
                trigger="hover"
                :open-delay="500"
                v-if="item.children && item.children.length"
              >
                <span
                  class="ellipsis cursor-pointer item_span"
                  slot="reference"
                  :class="{
                    item_select:
                      categoryParentList &&
                      categoryParentList.length &&
                      item.backgroundCategoryId ===
                        categoryParentList[0].backgroundCategoryId,
                  }"
                  :title="item.name"
                >
                  {{ item.name }}<i class="el-icon-caret-bottom"></i>
                </span>
                <el-cascader-panel
                  :props="{ value: 'backgroundCategoryId', label: 'name' }"
                  :options="item.children"
                  v-model="choosedCategoryIds"
                  @change="choosedCategory"
                >
                </el-cascader-panel>
              </el-popover>
              <span
                class="ellipsis cursor-pointer item_span"
                v-else
                @click="
                  choosedCategory(
                    item.backgroundCategoryId ? [item.backgroundCategoryId] : []
                  )
                "
                :class="{
                  item_select:
                    ((!categoryParentList || !categoryParentList.length) &&
                      idx === 0 &&
                      index === 0) ||
                    (categoryParentList &&
                      categoryParentList.length &&
                      item.backgroundCategoryId ===
                        categoryParentList[0].backgroundCategoryId),
                }"
                :title="item.name"
              >
                {{ item.name }}
              </span>
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="categoryList.length > 8"
        >
          <div
            class="more-button cursor-pointer"
            @click.stop="showMoreCategory = !showMoreCategory"
          >
            {{ !showMoreCategory ? "更多" : "收起" }}
            <i
              :class="
                showMoreCategory ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 属性 -->
      <el-row
        class="category_row"
        v-for="(attribute, attIndex) in attributeList"
        :key="attribute.attributeItemId"
        v-show="attIndex < 2 || showAllAttribute"
      >
        <el-col :span="3" class="row_lable">{{ attribute.name }}：</el-col>
        <el-col :span="19">
          <span v-show="!attribute.valueList.length">&nbsp;</span>
          <el-row
            v-for="(ele, idx) in Math.ceil(attribute.valueList.length / 8)"
            :key="idx"
          >
            <el-col
              :span="3"
              class="ellipsis category-item"
              v-for="item in attribute.valueList.slice(idx * 8, idx * 8 + 8)"
              :key="item.attributeValueId"
              v-show="showMoreAttributeList[attIndex] || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedAttributeItem(item, attIndex)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="attribute.valueList.length > 8"
        >
          <div
            class="more-button cursor-pointer"
            @click.stop="changeMore(attIndex)"
          >
            {{ !showMoreAttributeList[attIndex] ? "更多" : "收起" }}
            <i
              :class="
                showMoreAttributeList[attIndex]
                  ? 'el-icon-arrow-up'
                  : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <el-row
        :span="24"
        style="text-align: center"
        v-show="attributeList.length > 2"
      >
        <el-button
          type="text"
          v-show="showAllAttribute"
          @click="showAllAttribute = !showAllAttribute"
          >{{this.$t('message.collapseAttribute')}}</el-button
        >
        <el-button
          type="text"
          v-show="!showAllAttribute"
          @click="showAllAttribute = !showAllAttribute"
          >{{this.$t('message.openAttribute')}}</el-button
        >
      </el-row>
      <!-- 排序 -->
      <el-row class="good_sort">
        <el-col
          style="width: 66px"
          class="default_sort_but cursor-pointer"
          :class="{
            good_sort_default: !dataForm.timeSort,
          }"
        >
          <div @click="defaultSortHandle">默认</div>
        </el-col>
        <el-col style="width: 100px">
          <div
            class="sort_item cursor-pointer sort_center"
            @click="changeSortStatus(dataForm.timeSort + 1, dataForm.priceSort)"
          >
            发布时间
            <div class="sort_status">
              <i
                class="el-icon-caret-top"
                :class="{ sort_status_selected: dataForm.timeSort == 1 }"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ sort_status_selected: dataForm.timeSort == 2 }"
              ></i>
            </div>
          </div>
        </el-col>
        <!-- <el-col style="width: 350px">
          <div class="sort_item cursor-pointer price_sort_option">
            <div
              class="price_sort"
              @click="
                changeSortStatus(dataForm.timeSort, dataForm.priceSort + 1)
              "
            >
              价格
              <div class="sort_status">
                <i
                  class="el-icon-caret-top"
                  :class="{ sort_status_selected: dataForm.priceSort == 1 }"
                ></i>
                <i
                  class="el-icon-caret-bottom"
                  :class="{ sort_status_selected: dataForm.priceSort == 2 }"
                ></i>
              </div>
            </div>
            <el-popover placement="top-start" width="300" trigger="click">
              <el-input-number
                size="mini"
                v-model="minPrice"
                :precision="2"
                :controls="false"
              ></el-input-number
              >-
              <el-input-number
                size="mini"
                v-model="maxPrice"
                :precision="2"
                :controls="false"
              ></el-input-number>
              <div class="price_but">
                <el-button
                  type="text"
                  size="mini"
                  @click="
                    minPrice = '';
                    maxPrice = '';
                  "
                  >清空</el-button
                >
                <el-button size="mini" @click="queryMoney">确定</el-button>
              </div>
              <div slot="reference">
                <el-input
                  :readonly="true"
                  size="mini"
                  style="width: 130px"
                  v-model="dataForm.mixPrice"
                  :precision="2"
                  :controls="false"
                  placeholder="最低价格"
                >
                </el-input
                >-
                <el-input
                  :readonly="true"
                  size="mini"
                  v-model="dataForm.maxPrice"
                  style="width: 130px"
                  :precision="2"
                  :controls="false"
                  placeholder="最高价格"
                >
                </el-input>
              </div>
            </el-popover>
          </div>
        </el-col> -->
        <el-col style="width: 300px">
          <div class="sort_item cursor-pointer">
            备件名称/编码
            <el-input
              style="width:168px"
              placeholder="请输入备件名称/编码"
              clearable
              size="mini"
              @clear="searchHandle"
              v-model.trim="dataForm.inputText"
            >
            </el-input>
          </div>
        </el-col>
        <el-col style="width: 250px">
          <div class="sort_item cursor-pointer">
            品牌
            <el-select
              v-model="dataForm.brand"
              placeholder="请选择"
              size="mini"
              clearable
              filterable
              multiple
              remote
              :remote-method="getBrandList"
              :loading="brandLoading"
              @change="changeBrand"
            >
              <el-option
                v-for="item in brandList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="sort_item cursor-pointer">
            库存所在地
            <el-cascader
              v-model="dataForm.area"
              :options="options"
              :props="{
                value: 'label',
              }"
              size="mini"
              clearable
              @change="changeArea"
            ></el-cascader>
          </div>
        </el-col>

        <el-col style="width: 170px">
          <div class="sort_item cursor-pointer" style="height: 56px">
            <el-button type="primary" size="mini" @click="searchHandle">查询</el-button>
            <el-button size="mini" @click="resetHandle">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <!-- 列表 -->
      <el-table
        :data="dataList"
        border
        @sort-change="sortChange"
        ref="multipleTable"
        v-loading="dataListLoading"
      >
        <!-- <el-table-column type="selection"
                         width="50"
                         v-if="activited !== '01'"
                         label="全选"></el-table-column> -->
        <el-table-column prop="" header-align="center" label="备件">
          <template slot-scope="scope">
            <!-- <div @click="goodDetailHandle(scope.row)"> -->
            <good-detail :dataInfo="scope.row | formatDataInfo"></good-detail>
            <!-- </div> -->
          </template>
        </el-table-column>
        <!-- <el-table-column prop=""
                         header-align="center"
                         align="center"
                         width="100"
                         label="单位">
        </el-table-column> -->
        <el-table-column
          prop="price"
          header-align="center"
          align="center"
          width="150"
          label="价格"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="text_color">{{
              scope.row.price | formatterPrice
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="supplyNum"
          header-align="center"
          align="center"
          width="150"
          label="库存"
        >
          <template slot-scope="scope">
            {{ scope.row.supplyNum || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="150"
          label="操作"
        >
          <template slot-scope="scope">
            <!-- 不能修改详情页 buttonFlag按钮显示(BY 显示备用按钮,LY 显示领用按钮)-->
            <el-button type="primary" size="small" @click="consult(scope.row)">
              咨询
            </el-button>
            <el-button type="primary" size="small" @click="datail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="dataForm.page"
        :page-size="dataForm.limit"
        :total="total"
        layout="total, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import goodDetail from '@/views/modules/storeSpare/sharedSpareParts/components/goodDetail'
// import { delete } from 'vue/types/umd'
import { openOther } from '@/utils'
export default {
  name: 'storeStock', // 备件库查询
  data () {
    return {
      dataForm: {
        page: 1,
        limit: 10,
        inputText: '',
        model: '',
        mixPrice: '',
        maxPrice: '',
        sort: '',
        brand: [],
        area: [],
        priceSort: 0, // 0 不显示 1 升序 2 降序
        timeSort: 0 // 0 不显示 1 升序 2 降序
        // attributeValueIds: []
      },
      categoryParentList: [],
      categoryList: [], // 当前可选择类目
      attributeList: [], // 属性
      showMoreCategory: false, // 显示所有系列
      showMoreAttributeList: [], // 属性是否显示全部
      showAllAttribute: false, // 显示所有的属性
      choosedAttribute: [], // 已选中的属性
      choosedCategoryIds: [], // 已选中的类目
      dataListLoading: false,
      dataList: [], // 商品列表
      brandList: [], // 品牌列表
      brandLoading: false, // 品牌加载中
      brandTime: null, // 品牌检索定时器
      minPrice: null,
      maxPrice: null,
      total: 0,
      options: [] // 省市区
    }
  },
  components: {
    goodDetail
  },
  filters: {
    formatDataInfo (row) {
      let info = {
        url: '', // 图片
        name: '', // 名称
        norms: '', // 规格
        brand: '', // 品牌
        type: ''
      }
      info.url = row.url
      info.name = row.sparePartsName
      info.norms = (row.specification || '') + ' ' + (row.model || '')
      info.brand = row.brand
      info.type = row.supplyCode
      return info
    },
    formatterPrice (value) {
      if (!value || !Number(value)) {
        return '协议价'
      }
      return '￥' + Number(value).toFixed(2)
    }
  },
  methods: {
    // 确认输入查询钱
    queryMoney () {
      this.resetRoute({
        priceMin: this.minPrice,
        priceMax: this.maxPrice
      })
    },
    // 获取原始类目树
    getOriginCategory () {
      this.$http
        .get('/front/order/lclb/share-business/initial-category-tree')
        .then(({ data }) => {
          let origin = data.data || []
          let categoryList = [
            {
              backgroundCategoryId: '',
              name: '不限'
            }
          ]
          origin.forEach((oneLevel, oneIndex) => {
            let val = {
              backgroundCategoryId: oneLevel.backgroundCategoryId,
              name: oneLevel.name,
              parentId: oneLevel.parentId
            }
            if (oneLevel.children && oneLevel.children.length) {
              val.children = []
              oneLevel.children.forEach((twoLevel, twoIndex) => {
                let twoVal = {
                  backgroundCategoryId: twoLevel.backgroundCategoryId,
                  name: twoLevel.name,
                  parentId: twoLevel.parentId
                }
                if (twoLevel.children && twoLevel.children.length) {
                  twoVal.children = []
                  twoLevel.children.forEach((threeLevel, threeIndex) => {
                    let threeVal = {
                      backgroundCategoryId: threeLevel.backgroundCategoryId,
                      name: threeLevel.name,
                      parentId: threeLevel.parentId
                    }
                    twoVal.children.push(threeVal)
                  })
                }
                val.children.push(twoVal)
              })
            }
            categoryList.push(val)
          })
          this.categoryList = categoryList
          this.showMoreCategory = categoryList.length <= 8
          this.searchParentList()
        })
    },
    // 查找当前选中的类目
    searchParentList () {
      if (this.$route.query.categoryId) {
        let partentList = this.findParent(
          [],
          { backgroundCategoryId: this.$route.query.categoryId },
          this.categoryList
        )
        this.categoryParentList = partentList
        if (partentList.length > 1) {
          this.choosedCategoryIds = partentList.slice(1).map((item) => {
            return item.backgroundCategoryId
          })
        } else {
          this.choosedCategoryIds = []
        }
      } else {
        this.categoryParentList = []
        this.choosedCategoryIds = []
      }
    },
    // 递归查树
    findParent (parents = [], childNode, treeData = []) {
      if (treeData && treeData.length) {
        treeData.forEach((item) => {
          // for (let i = 0; i < treeData.length; i++) {
          // 父节点查询条件
          // console.log(item.backgroundCategoryId, childNode.backgroundCategoryId, '---')
          if (item.backgroundCategoryId === childNode.backgroundCategoryId) {
            // 如果找到结果,保存当前节点
            parents.unshift({
              backgroundCategoryId: item.backgroundCategoryId,
              name: item.name
            })
            // 用当前节点再去原数据查找当前节点的父节点
            this.findParent(
              parents,
              { backgroundCategoryId: item.parentId },
              this.categoryList
            )
          } else {
            if (item.children instanceof Array) {
              // 没找到，遍历该节点的子节点
              this.findParent(parents, childNode, item.children)
            }
          }
        })
      }
      return parents
    },
    // 获取数据列表
    getDataList () {
      this.searchParentList()
      this.$http
        .post('/front/order/lclb/share-business/conditional-filter', {
          categoryIds: this.$route.query.categoryId
            ? [this.$route.query.categoryId]
            : [],
          attributeValueIds: this.choosedAttribute || []
        })
        .then(({ data }) => {
          // this.categoryParentList = this.$route.query.categoryId ? data.data.categoryChainList : []
          // if (this.categoryParentList.length > 1) {
          //   this.choosedCategoryIds = this.categoryParentList.slice(1).map(item => {
          //     return item.backgroundCategoryId
          //   })
          // } else {
          //   this.choosedCategoryIds = []
          // }
          let attributeList = data.data.attributeList
          attributeList.forEach((item) => {
            let flag = item.valueList.some((val) => {
              return val.selected
            })
            item.valueList.unshift({
              name: '不限',
              attributeValueId: '',
              selected: !flag
            })
          })
          this.attributeList = attributeList
          this.showMoreAttributeList = new Array(
            this.attributeList.length
          ).fill(false)
          this.$set(this, 'showMoreAttributeList', this.showMoreAttributeList)
        })
    },
    // 获取商品列表
    getGoodList () {
      this.dataListLoading = true
      let sort = ''
      if (this.dataForm.priceSort && Number(this.dataForm.priceSort) % 3 > 0) {
        sort =
          'price ' + (Number(this.dataForm.priceSort) % 3 > 1 ? 'desc' : 'asc')
      }
      if (this.dataForm.timeSort && Number(this.dataForm.timeSort) % 3 > 0) {
        if (sort) {
          sort += ','
        }
        sort =
          ' create_time ' +
          (Number(this.dataForm.timeSort) % 3 > 1 ? 'desc' : 'asc')
      }
      this.$http
        .post(`/front/order/lclb/sparePartsShare/shareList`, {
          companyId: this.$store.state.user.defaultCompanyId || '',
          ...this.dataForm,
          categoryIds: this.$route.query.categoryId
            ? [this.$route.query.categoryId]
            : [],
          attributeValueIds: this.choosedAttribute || [],
          sort: sort
        })
        .then(({ data }) => {
          if (data.data) {
            this.dataList = data.data.data || []
            this.total = Number(data.data.count) || 0
          } else {
            this.dataList = []
            this.total = 0
          }
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 检索名称
    searchHandle () {
      this.resetRoute({
        page: 1,
        inputText: this.dataForm.inputText
      })
    },
    // 改变类目
    choosedCategory (category) {
      if (category && category.length) {
        this.resetRoute({
          page: 1,
          attribute: [],
          categoryId: category[category.length - 1]
        })
      } else {
        this.resetRoute({
          page: 1,
          attribute: [],
          categoryId: '',
          priceMin: '',
          priceMax: '',
          brand: '',
          province: '',
          city: '',
          priceSort: 0,
          timeSort: 0
        })
      }
    },
    choosedAttributeItem (item, attIndex) {
      let choosedAttribute = this.choosedAttribute
      if (item.attributeValueId) {
        let index = choosedAttribute.findIndex((att) => {
          return att === item.attributeValueId
        })
        if (index > -1) {
          choosedAttribute.splice(index, 1)
        } else {
          choosedAttribute.push(item.attributeValueId)
        }
      } else {
        // 选择不限
        let valueList = this.attributeList[attIndex].valueList
        valueList.forEach((val) => {
          let idx = choosedAttribute.findIndex((att) => {
            return att === val.attributeValueId
          })
          if (idx > -1) {
            choosedAttribute.splice(idx, 1)
          }
        })
      }
      this.resetRoute({
        attribute: choosedAttribute,
        page: 1
      })
    },
    // 更改属性显示隐藏
    changeMore (index) {
      this.$set(
        this.showMoreAttributeList,
        index,
        !this.showMoreAttributeList[index]
      )
    },
    // 默认排序
    defaultSortHandle () {
      this.resetRoute({
        timeSort: 0,
        priceSort: 0,
        page: 1
      })
    },
    // 更改排序
    changeSortStatus (timeSort, priceSort) {
      this.resetRoute({
        timeSort: timeSort % 3,
        priceSort: priceSort % 3,
        page: 1
      })
    },
    // 更改库存所在地
    changeArea (val) {
      let province = val && val.length > 0 ? val[0] : ''
      let city = val && val.length > 1 ? val[1] : ''
      this.resetRoute({
        province: province,
        city: city,
        page: 1
      })
    },
    // 更改品牌
    changeBrand (brandId) {
      this.resetRoute({
        brand: brandId,
        page: 1
      })
    },
    // 获取品牌列表
    getBrandList (val) {
      if (this.brandTime) {
        clearInterval(this.brandTime)
      }
      this.brandTime = setTimeout(() => {
        this.brandLoading = true
        this.$http
          .post(`/front/order/lclb/sparePartsShare/brandList`, {
            brand: val,
            type: 'PC'
          })
          .then(({ data }) => {
            this.brandList = data.data || []
          })
          .finally(() => {
            this.brandLoading = false
          })
      }, 200)
    },
    // 更改当前页
    changePage (page) {
      this.resetRoute({
        page: page
      })
    },
    // 更改当前条数
    pageSizeChangeHandle (limit) {
      this.resetRoute({
        page: 1,
        limit: limit
      })
    },
    // 获取省市区树
    getAreaTree () {
      this.$request.get(`/front/sys/sysProvince/queryTree`).then((data) => {
        let options = data.map((pro) => {
          let children = []
          if (pro.children) {
            children = pro.children.map((city) => {
              return {
                value: city.codeC,
                label: city.name
              }
            })
          }
          return {
            value: pro.codeP,
            label: pro.name,
            children: children
          }
        })
        this.options = options || []
      })
    },
    resetRoute (obj) {
      this.choosedCategoryIds = []
      let brand = []
      if (this.$route.query.brand) {
        brand = this.$route.query.brand.split(',')
      }
      let queryOri = {
        inputText: this.$route.query.inputText || '',
        page: this.$route.query.page || 1,
        limit: this.$route.query.limit || 10,
        priceMin: this.$route.query.priceMin || '',
        priceMax: this.$route.query.priceMax || '',
        brand: brand,
        province: this.$route.query.province || '',
        city: this.$route.query.city || '',
        priceSort: Number(this.$route.query.priceSort) || 0,
        timeSort: Number(this.$route.query.timeSort) || 0,
        attribute: this.choosedAttribute || [],
        categoryId: this.$route.query.categoryId
      }
      let query = Object.assign(queryOri, obj)
      this.$router.push({
        name: 'shareGoodList',
        query: {
          inputText: query.inputText || '',
          page: query.page || 1,
          limit: query.limit || 10,
          priceMin: query.priceMin || '',
          priceMax: query.priceMax || '',
          brand: query.brand ? query.brand.join() : '',
          province: query.province || '',
          city: query.city || '',
          priceSort: query.priceSort,
          timeSort: query.timeSort,
          attribute:
            query.attribute && query.attribute.length
              ? query.attribute.join()
              : '',
          categoryId: query.categoryId || ''
        }
      })
    },
    // 详情
    datail (row) {
      if (!row.sparePartsId) {
        return false
      }
      openOther(`spareShareGoodsDetail?sparePartsId=${row.sparePartsId}`)
    },
    // 咨询
    consult (row) {
      this.$confirm(row.mobile, '请致电供应商', {
        confirmButtonText: '知道了',
        type: 'warning',
        center: true,
        showCancelButton: false
      })
        .then(() => {})
        .catch(() => {})
    },
    goodDetailHandle (row) {
      if (!row.sparePartsId) {
        return false
      }
      openOther(`shareGoodDetail?sparePartsId=${row.sparePartsId}`)
      // &defaultCompany=${this.$store.state.user.defaultCompanyId}
    },
    // 设置排序
    sortChange (o) {
      // desc倒序，asc正序
      let order = ''
      if (o.order === 'descending') {
        order = 'desc'
      }
      if (o.order === 'ascending') {
        order = 'asc'
      }
      if (order) {
        this.changeSortStatus(0, order === 'asc' ? 1 : 2)
        return
      }
      this.changeSortStatus(0, 0)
    },
    // 重置
    resetHandle () {
      this.dataForm.brand = []
      this.dataForm.area = []

      this.resetRoute({
        inputText: '',
        page: 1,
        timeSort: 0,
        priceSort: 0,
        province: '',
        city: '',
        brand: '',
        attribute: [],
        categoryId: ''
      })
    }
  },
  watch: {
    $route () {
      let query = this.$route.query
      this.dataForm.page = Number(query.page) || 1
      this.dataForm.limit = Number(query.limit) || 10
      this.dataForm.mixPrice = query.priceMin || null
      this.dataForm.maxPrice = query.priceMax || null
      this.minPrice = null
      this.maxPrice = null
      this.dataForm.brand = query.brand ? query.brand.split(',') : []
      // 地区
      this.dataForm.province = query.province || ''
      this.dataForm.city = query.city || ''
      this.dataForm.inputText = query.inputText || ''
      let area = []
      if (this.dataForm.province) {
        area.push(this.dataForm.province)
        if (this.dataForm.city) {
          area.push(this.dataForm.city)
        }
      }
      this.dataForm.area = area
      this.choosedAttribute = []
      if (query.attribute) {
        this.choosedAttribute = query.attribute.split(',')
      }
      // 排序
      this.dataForm.priceSort = Number(query.priceSort) % 3 || 0
      this.dataForm.timeSort = Number(query.timeSort) % 3 || 0
      this.getDataList()
      this.getGoodList()
    },
    activited (val) {
      this.getOriginCategory()
    }
  },
  created () {
    // this.getBrandList()
    this.getAreaTree()
    this.getOriginCategory()
  },
  mounted () {
    let query = this.$route.query
    this.dataForm.page = Number(query.page) || 1
    this.dataForm.limit = Number(query.limit) || 10
    this.dataForm.mixPrice = query.priceMin || null
    this.dataForm.maxPrice = query.priceMax || null
    this.minPrice = null
    this.maxPrice = null
    this.dataForm.brand = query.brand ? query.brand.split(',') : []
    this.dataForm.inputText = query.inputText || ''
    // 地区
    this.dataForm.province = query.province || ''
    this.dataForm.city = query.city || ''
    let area = []
    if (this.dataForm.province) {
      area.push(this.dataForm.province)
      if (this.dataForm.city) {
        area.push(this.dataForm.city)
      }
    }
    this.dataForm.area = area
    this.choosedAttribute = []
    if (query.attribute) {
      this.choosedAttribute = query.attribute.split(',')
    }
    // 排序
    this.dataForm.priceSort = Number(query.priceSort) % 3 || 0
    this.dataForm.timeSort = Number(query.timeSort) % 3 || 0
    this.getDataList()
    this.getGoodList()
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
.home_page {
  .search_div {
    padding: 10px 30px;
    /deep/ .el-input-group__append {
      background: #2e88ff;
      color: #fff;
    }
  }
  .category_row {
    background: #fff;
    border-top: 1px solid #dedede;
    display: flex;
    line-height: 50px;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    .row_lable {
      padding-left: 10px;
      background: #f2f2f2;
      color: #333333;
      overflow: hidden;
    }
    .choosed_category_item {
      display: flex;
      align-items: center;
      height: 30px;
    }
    // 已选中的类目展示
    .category_next {
      margin-left: 5px;
    }
    .choosed_category {
      border: 1px solid #2e88ff;
      margin-left: 5px;
      display: flex;
      height: 20px;
      line-height: 20px;
      // align-items: center;
      .choosed_category_name {
        padding: 0px 10px;
        line-height: 18px;
      }
      .category_close {
        background: #2e88ff;
        color: #fff;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .category-item {
      text-align: center;
      // display: flex;
      align-items: center;
      min-height: 30px;
      .item_span {
        padding: 0px 5px;
        max-width: 100%;
        float: left;
        margin: 0 auto;
      }
      .item_select {
        color: #0064c0;
        font-weight: 400;
      }
    }
    .category-more {
      text-align: right;
      padding-right: 5px;
      .more-button {
        text-align: center;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        // line-height: 20px;
        // margin: 5px;
        padding: 5px 10px;
        display: inline;
        color: #999999;
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
  .good_sort {
    display: flex;
    margin: 6px 0 20px;
    text-align: center;
    line-height: 56px;
    font-size: 14px;
    color: #666666;
    background: #fff;
    border: 1px solid #e1e1e1;
    /deep/ .price_sort_option .el-input__inner {
      background-color: rgb(245, 247, 250);
      cursor: not-allowed;
    }
    .default_sort_but {
      &:hover {
        background: #2e88ff;
        color: #fff;
      }
    }
    .good_sort_default {
      background: #2e88ff;
      color: #fff;
    }
    .sort_item {
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-left: 1px solid #e1e1e1;
      .sort_status {
        margin-left: 5px;
        font-size: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #bebebe;
        .sort_status_selected {
          color: #2e88ff;
        }
      }
      .price_sort {
        display: flex;
      }
    }
    .sort_center {
      justify-content: center;
    }
  }
  .text_color {
    color: #0064c0;
  }
  // .good{
  //   display: flex;
  //   .good_img{
  //     width: 60px;
  //     padding: 5px;
  //     flex-shrink: 0;
  //   }
  //   .good_name{
  //     flex-grow: 1;
  //   }
  // }
  .el-pagination {
    background: #fff;
    padding: 22px;
  }
  .fix {
    margin-top: 20px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    line-height: 64px;
    background-color: #fff;
    .left {
      // line-height: 50px;
      flex-shrink: 0;
      flex-grow: 1;
      .check-all {
        // margin-left: 15px;
      }
      span {
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .div1 {
      margin-left: 380px;
      width: 140px;
      .red {
        font-weight: bold;
        color: red;
      }
    }
    .div2 {
      // margin-left: 40px;
      padding: 0 15px;
      min-width: 150px;
      .red {
        font-weight: bold;
        font-size: 15px;
        color: red;
      }
      .discount {
        text-decoration: line-through;
        color: #aaaaaa;
      }
    }
    .div3 {
      width: 141px;
      margin-left: 20px;
      color: #fff;
      background-color: #1e64a9;
      font-size: 18px;
    }
  }
}
.price_but {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}
// .item_span{
//   padding: 0px 5px;
//   max-width: 100%;
//   float: left;
//   margin: 0 auto;
// }
</style>
